import { FC, useEffect, useState } from 'react';
import { cx } from '@emotion/css';
import { Trans } from 'react-i18next';

export const MediaPreview: FC<{
  mediaUrl: string;
}> = ({ mediaUrl }) => {
  const [currentMediaUrl, setCurrentMediaUrl] = useState(mediaUrl);
  const isVideo = mediaUrl.endsWith('.mp4');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const playNextMedia = () => {
      setCurrentMediaUrl(mediaUrl);
    };

    const timeout = setTimeout(playNextMedia, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, [mediaUrl]);

  const handleMediaLoad = () => {
    setIsLoading(false);
  };

  if (!currentMediaUrl) {
    return null;
  }

  return (
    <div
      className={cx('w-52 h-24 flex items-center justify-center', {
        'animate-pulse bg-gray-100': isLoading,
        'bg-black': !isLoading,
      })}
    >
      {isVideo ? (
        <video
          src={currentMediaUrl}
          loop
          autoPlay
          muted
          onLoadedData={handleMediaLoad}
        >
          <Trans i18nKey="campaign_details.media_preview.video_not_supported" />
        </video>
      ) : (
        <img
          src={currentMediaUrl}
          onLoad={handleMediaLoad}
          style={{
            objectFit: 'contain',
            width: '100%',
            height: '100%',
          }}
        />
      )}
    </div>
  );
};
